<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <EmployeeFolderForm
      v-if="!isLoading"
      :employeeFolderData="employeeFolder"
      :imageSrc="imageSrc"
      :submitName="$t('add')"
      v-on:addOrUpdateEmployeeFolder="addEmployeeFolder()"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import EmployeeFolderForm from "@/components/employees/employeeFolders/EmployeeFolderForm.vue";
import createToastMixin from "@/utils/create-toast-mixin";
import EmployeeFolder from "@/models/employees/employeeFolders/EmployeeFolder";
import DEFAULT_IMG from "@/assets/images/employeeFolders.svg";

export default {
  name: "EmployeeFolderAdd",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    EmployeeFolderForm,
  },
  computed: {
    ...mapGetters(["employeeToken"]),
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      employeeFolder: new EmployeeFolder(),
      imageSrc: DEFAULT_IMG,
    };
  },
  methods: {
    async addEmployeeFolder() {
      this.isLoading = true;
      try {
        let response = await this.employeeFolder.addOrUpdateEmployeeFolder(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.employeeFolder.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    if (this.employeeToken) {
      this.employeeFolder.employeeToken = this.employeeToken;
    }
  },
};
</script>
